import React from 'react';

export default function MobileProductHint({ children }) {
  return (
    <div className='mp-hint'>
      <i className='bi bi-info-circle-fill' aria-hidden='true' />
      <p>{children}</p>
    </div>
  );
}
